<template>
    <div class="dashboard-header">
        <b-button-group class="tabs-buttons">
            <b-button
                class="btn-projecten btn-link-type"
                v-if="!$authUser.isStudent()"
                :class="filters.groups && 'active'"
                variant="primary"
                :title="$t('dashboard.projects')"
                @click="updateFilter('groups')">
                {{ $t('dashboard.projects') }}
            </b-button>
            <b-button
                class="btn-projecten btn-link-type"
                v-if="$authUser.isStudent()"
                :class="filters.projects && 'active'"
                variant="primary"
                :title="$t('dashboard.projects')"
                @click="updateFilter('projects')">
                {{ $t('dashboard.projects') }}
            </b-button>
            <b-button
                class="btn-projecten btn-link-type"
                v-if="$authUser.isTeacher()"
                :class="filters.projects && 'active'"
                variant="primary"
                :title="$t('dashboard.papers')"
                @click="updateFilter('projects')">
                {{ $t('dashboard.papers') }}
            </b-button>
            <b-button
                class="btn-magazines btn-link-type"
                v-if="hasMagazines"
                :class="filters.magazines && 'active'"
                variant="primary"
                title="Magazine"
                @click="updateFilter('magazines')">
                Magazines
            </b-button>
        </b-button-group>

        <b-form-select
            class="apprentice-primary-select school-year-select"
            v-if="hasContentToDisplay"
            :value="sortedIn"
            :options="seasons"
            value-field="id"
            text-field="season"
            @change="onSeasonChange($event)">
        </b-form-select>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-show-header-component',
    props: {
        filters: Object,
        sortedIn: Number,
        seasonsIn: Array,
        hasMagazines: Boolean,
        currentSeasonId: Number,
        hasCards: Boolean,
    },
    data() {
        return {
            seasons: this.seasonsIn.map((season) => {
                if (season.id !== this.currentSeasonId) {
                    return season;
                }
                let currentSeason = { ...season };
                currentSeason.season = this.$t('dashboard.current_school_year');
                return currentSeason;
            }),
        };
    },
    computed: {
        hasContentToDisplay() {
            if (this.$authUser.isStudent() && this.filters.projects && this.hasCards) {
                return true;
            }

            return !this.$authUser.isStudent() && this.hasCards && (this.filters.groups || this.filters.projects);
        },
    },
    methods: {
        updateFilter(type) {
            this.$emit('change-filter', type);
        },

        onSeasonChange(id) {
            this.$emit('sorting-update', id);
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: baseline;
    margin-bottom: map-get($grid-gutter-spacing, twenty-one);
}

.tabs-buttons {
    .btn {
        margin-left: 0;
        font-size: $base-font-size;
        color: $nav-link-color;
        padding: map-get($grid-padding-spacing, 'zero') map-get($grid-padding-spacing, 'fifteen');
        min-width: 103px;

        &:first-child {
            padding-left: 0;
        }

        &.active {
            background-color: transparent;
            border-color: transparent;
            border: none;
            color: $primary;
            font-weight: $font-weight-medium;

            &:after {
                background-color: $primary;
                left: calc(50% - 10.5px);
                opacity: 1;
            }
        }

        &:after {
            display: block;
            content: '';
            width: 21px;
            height: 5px;
            background-color: transparent;
            margin-top: map-get($grid-gutter-spacing, 'fifteen');
            position: relative;
            left: -21px;
            opacity: 0;
            transition: all 0.3s ease-in-out;
        }

        &:hover {
            border: none;
            color: $primary;
            font-weight: $font-weight-medium;

            &:after {
                background-color: $primary;
                left: calc(50% - 10.5px);
                opacity: 1;
            }
        }

        &:not(:disabled):not(.disabled):active,
        &:not(:disabled):not(.disabled).active:focus {
            box-shadow: none;
            color: $primary;
            background-color: transparent;
        }
    }
}

.school-year-select ::v-deep {
    flex: 1 0 100%;
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
    border: 1px solid $primary;
    width: 100%;
    color: $primary;

    button {
        padding-bottom: map-get($grid-gutter-spacing, 'eight');
        padding-top: map-get($grid-gutter-spacing, 'eight');
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .dashboard-header {
        .btn-group:not(.school-year-select) {
            margin-top: 9px;
        }
    }

    .school-year-select {
        margin-top: 0;
        flex: 0 1 auto;
        width: auto;
        min-width: 160px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .school-year-select {
        margin-top: 0;
        margin-left: map-get($grid-gutter-spacing, twenty-one);
    }
}
</style>
